module.exports = __webpack_public_path__ + "static/img/female-bg-pt.30ec2976.png";